var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_131_420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-56.0868 168.627L-56.1111 168.614L-56.1379 168.606L-77.6649 162.692L-79.5267 146.169L155.123 116.452L153.721 135.152L148.308 142.211L133.808 151.646L133.786 151.661L133.768 151.68L121.639 164.105L110.231 170.641L110.199 170.66L110.174 170.687L92.3252 190.096L63.1522 208.583L29.9108 193.875L29.8863 193.864L29.86 193.859L-8.60223 186.344L-21.3323 181.717L-21.3495 181.711L-21.3676 181.707L-38.2487 178.379L-56.0868 168.627Z",
    fill: "#DCF0F7",
    stroke: "black",
    strokeWidth: 0.47654
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.0868 150.995L-56.1201 150.977L-56.1573 150.97L-79.9637 146.522L-67.2676 135.917L-56.1037 130.216L-38.2449 123.311L-38.218 123.3L-38.1943 123.284L-23.2313 112.82L-8.67887 110.94L-0.739195 112.823L-0.714351 112.829L-0.688827 112.829L67.099 114.14L67.1093 114.14L67.1196 114.139L86.5077 112.831L100.059 115.446L100.087 115.452L100.117 115.45L112.322 114.795L112.328 114.795L133.935 114.14L157 115.421L148.319 124.572L133.808 134.014L133.786 134.029L133.768 134.048L121.639 146.473L110.231 153.009L110.199 153.028L110.174 153.055L92.3252 172.464L63.1521 190.951L29.9107 176.243L29.8863 176.232L29.86 176.227L-8.60235 168.712L-21.3323 164.085L-21.3496 164.079L-21.3676 164.075L-38.2487 160.747L-56.0868 150.995Z",
    fill: "#7DDAF8",
    stroke: "black",
    strokeWidth: 0.47654
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5552 31.6914L18.548 31.6734L18.5401 31.6558L18.0638 30.5895C16.9228 28.0354 16.3331 25.2694 16.3331 22.4721L16.3331 19.6122C16.3331 19.535 16.3393 19.4579 16.3516 19.3816C16.4918 18.5119 17.3695 17.9678 18.2108 18.2289L21.585 19.276C22.7863 19.6487 23.7776 20.5056 24.3202 21.6403L26.1773 25.5235C26.4307 26.0534 26.6132 26.6144 26.7199 27.192L27.1027 29.2634C27.5341 31.5979 26.0621 33.8615 23.7533 34.4141C21.6052 34.9282 19.4041 33.7934 18.577 31.7453L18.5552 31.6914Z",
    fill: "#DC965A",
    stroke: "#7C3626",
    strokeWidth: 2.13119
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2677 32.4835L56.2591 32.4662L56.2498 32.4492L53.5497 27.4996L52.6143 28.0099L53.4827 27.3923C52.6493 26.2205 52.582 24.6684 53.3107 23.4288L53.9379 22.362C55.2711 20.0942 58.1056 19.2052 60.4952 20.3054C60.8641 20.4753 61.2115 20.6884 61.53 20.9403L64.5214 23.3058L65.1823 22.47L64.6057 23.366C66.4281 24.5388 66.4264 27.2038 64.6024 28.3741L59.9646 31.3498C59.4661 31.6696 59.0565 32.1103 58.7739 32.6308C58.2399 33.6141 56.8201 33.5897 56.3202 32.5886L56.2677 32.4835Z",
    fill: "#DC965A",
    stroke: "#7C3626",
    strokeWidth: 2.13119
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5926 38.4816C18.5253 33.7053 21.2003 29.4825 25.0469 26.5014V26.5014C27.4032 24.6753 30.1258 23.3792 33.0289 22.7018L35.7711 22.062L40.6781 21.4914C44.1669 21.0858 47.6996 21.6678 50.8739 23.1714V23.1714C56.3487 25.7648 60.2339 30.8427 61.3053 36.8052L65.0782 57.8025L72.1243 95.3123C72.8151 98.9899 72.5092 102.785 71.2382 106.305L63.8869 126.662L51.747 150.292C51.0415 151.665 49.4859 152.375 47.9864 152.008L38.8686 149.775L48.6257 114.131C49.3112 111.627 46.573 109.579 44.3645 110.944L37.4389 115.226L34.9173 117.274C34.1194 117.923 33.731 118.949 33.9 119.963L38.8686 149.775L29.8236 151.166C27.8621 151.468 25.9498 150.385 25.2003 148.547L19.2115 133.865C19.1321 133.67 19.0394 133.492 18.9315 133.311C17.7831 131.393 10.8573 118.925 10.5144 96.6405C10.238 78.6686 15.0609 51.4461 17.5926 38.4816Z",
    fill: "#7C3626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2285 37.0629C30.3368 38.1101 29.5757 39.0468 28.5286 39.1551C27.4814 39.2634 26.5447 38.5023 26.4364 37.4551C26.3281 36.408 27.0892 35.4713 28.1364 35.363C29.1836 35.2547 30.1202 36.0158 30.2285 37.0629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1962 35.1568C51.3045 36.2039 50.5434 37.1406 49.4962 37.2489C48.4491 37.3572 47.5124 36.5961 47.4041 35.5489C47.2958 34.5018 48.0569 33.5651 49.1041 33.4568C50.1512 33.3485 51.0879 34.1096 51.1962 35.1568Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8549 44.0858C48.2555 47.9589 45.605 54.4777 41.5473 54.8973C37.4896 55.317 33.5611 49.4786 33.1606 45.6055C32.76 41.7325 35.7247 38.2526 39.7825 37.8329C43.8402 37.4133 47.4544 40.2128 47.8549 44.0858Z",
    fill: "#D69A67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2652 40.9935C42.323 41.552 41.5978 43.8732 40.4198 43.995C39.2417 44.1168 38.0569 41.9932 37.9991 41.4347C37.9414 40.8763 38.8495 40.3248 40.0276 40.2029C41.2056 40.0811 42.2075 40.4351 42.2652 40.9935Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.5521,
    y1: 43.7758,
    x2: 40.9661,
    y2: 47.7786,
    stroke: "black",
    strokeWidth: 1.21782,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.152228,
    y: 0.152228,
    width: 75.6955,
    height: 75.6955,
    rx: 37.8478,
    stroke: "#858585",
    strokeWidth: 0.304456
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_131_420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d4aaf4230dae5efb51e4838d36e21684.svg";
export { ForwardRef as ReactComponent };